export const DEFAULT_ASSISTANT_MESSAGE = {
  content: '**Welcome to Numerator Narratives.**\n\nAsk a business question to get started.',
  id: 'assistant-welcome',
  role: 'assistant',
};

export const DEFAULT_DRAFT_NARRATIVE_NAME = 'Untitled Narrative';
export const CHAT_RESPONSE_POLL_INTERVAL_MS = 1000;
export const CHAT_RESPONSE_POLL_MAX_ATTEMPTS = 15;
